import React, { useRef, useState, useCallback, useEffect } from "react";
import { MoveHorizontal } from "lucide-react";

// Interactive before/after image slider
export default function BeforeAfterSlider({ before, after, beforeLabel = "What You See", afterLabel = "What We See", className = "" }) {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const draggingRef = useRef(false);

  const updateFromClientX = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let pct = ((clientX - rect.left) / rect.width) * 100;
    pct = Math.max(0, Math.min(100, pct));
    setPos(pct);
  }, []);

  useEffect(() => {
    const onMove = (e) => {
      if (!draggingRef.current) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      updateFromClientX(clientX);
    };
    const onUp = () => { draggingRef.current = false; };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchend", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchend", onUp);
    };
  }, [updateFromClientX]);

  const startDrag = (e) => {
    draggingRef.current = true;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    updateFromClientX(clientX);
  };

  return (
    <div
      ref={containerRef}
      className={`ba-slider ${className}`}
      onMouseDown={startDrag}
      onTouchStart={startDrag}
    >
      <img src={before} alt="Before" draggable="false" />
      {beforeLabel ? <span className="ba-label right-4">{beforeLabel}</span> : null}
      <div className="ba-after" style={{ width: `${pos}%` }}>
        <div style={{ width: containerRef.current ? containerRef.current.offsetWidth : "100%", height: "100%" }}>
          <img src={after} alt="After" draggable="false" style={{ width: containerRef.current ? containerRef.current.offsetWidth : "100%" }} />
        </div>
        {afterLabel ? <span className="ba-label left-4">{afterLabel}</span> : null}
      </div>
      <div className="ba-handle" style={{ left: `${pos}%` }}>
        <div className="ba-handle-grip">
          <MoveHorizontal size={20} strokeWidth={1.5} />
        </div>
      </div>
    </div>
  );
}
